// extracted by mini-css-extract-plugin
module.exports = {"indicator-dots":"_16MME8Bn","indicatorDots":"_16MME8Bn","dot":"_1BcKf_vs","selected":"_35OVFlfs"};